import {nthArg, get, includes, keyBy, filter, pickBy, createSelector} from 'vendor';
import {shorten} from 'helpers';

export const user = createSelector(
  state => JSON.stringify(state.googleCalendar.user || null),
  JSON.parse,
);

export const userIsOnline = createSelector(
  state => JSON.stringify(!state.session.offline && state.googleCalendar.ready && state.googleCalendar.user || null),
  JSON.parse,
);

export const settings = createSelector(
  [ state => state.googleCalendar, state => state.settings.googleCalendar ],
  ( googleCalendar, preferences ) => ({
    defaultCalendar: 'primary',
    importCalendars: [],
    ...preferences,
    ...googleCalendar,
  })
);

export const defaultCalendar = createSelector(
  [ user, state => state.settings.googleCalendar ],
  ( user, preferences ) => user ? get(preferences, 'defaultCalendar', 'primary') : null,
);

const calendars = createSelector(
  state => state.googleCalendar.calendars,
  calendars => keyBy(calendars, 'id'),
);

export const readableCalendars = createSelector(
  calendars,
  calendars => pickBy(calendars, { accessRole: 'reader' }),
);

export const writableCalendars = createSelector(
  calendars,
  calendars => filter(calendars, ({ accessRole }) => /writer|owner/.test(accessRole)),
);

export const watchableCalendars = createSelector(
  settings,
  ({ calendars = [], importCalendars, channels = {} }) => {
    return calendars.filter(({ id, accessRole }) => /writer|owner/.test(accessRole) && includes(importCalendars, id)).map(calendar => ({
      ...calendar,
      channel: channels[calendar.id],
    })).slice(0, 5);
  }
);

export const calendarById = createSelector(
  [ calendars, nthArg(1) ],
  ( calendars, { id }) => calendars[id],
);

export const calendarName = createSelector(
  [ calendarById ],
  ( calendar ) => [
    'Google',
    calendar && !calendar.primary && shorten(calendar.summary, { words: 5 }),
  ].filter(Boolean).join(' - '),
);

export const events = createSelector(
  [ state => state.googleCalendar.events, state => get(state.settings, 'googleCalendar.importCalendars') ],
  ( events, calendars ) => pickBy(events, event => includes(calendars, event.googleCalendarId)),
);

export const eventsProgress = state => state.googleCalendar.progress;

export function isGoogleEventId(id) {
  return /^g_[0-9a-z]{26}$/.test(id);
}
